import { render, staticRenderFns } from "./MessageNotifications.vue?vue&type=template&id=71c2d6d2&"
import script from "./MessageNotifications.vue?vue&type=script&lang=js&"
export * from "./MessageNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports